const PHONE_COUNTRIES = Object.freeze([
  Object.freeze({ code: 'US', dial: '+1' }),
  Object.freeze({ code: 'ES', dial: '+34' }),
  Object.freeze({ code: 'MR', dial: '+222' }),
]);

const ELIGIBLE_TYPES = new Set(['text', 'email', 'password', 'tel', 'number', 'search']);

export function authenticatedInputEligible(control = {}) {
  if (control.login === true || control.dataset?.loginInput !== undefined) return false;
  const tag = String(control.tagName || '').toUpperCase();
  if (tag === 'TEXTAREA') return true;
  if (tag !== 'INPUT') return false;
  return ELIGIBLE_TYPES.has(String(control.type || 'text').toLowerCase());
}

export function phoneCountryOptions() {
  return PHONE_COUNTRIES.map((item) => ({ ...item }));
}

export function normalizePhoneValue(countryCode, localValue) {
  const digits = String(localValue || '').replace(/\D+/g, '');
  if (!digits) return '';
  const country = PHONE_COUNTRIES.find(({ code }) => code === String(countryCode || '').toUpperCase())
    || PHONE_COUNTRIES[0];
  const dialDigits = country.dial.replace(/\D+/g, '');
  const localDigits = digits.startsWith(dialDigits) ? digits.slice(dialDigits.length) : digits;
  return `${country.dial}${localDigits}`;
}

function inferredLabel(control) {
  return String(control.getAttribute?.('aria-label') || control.placeholder || control.name || 'Value')
    .trim().replaceAll('_', ' ');
}

export function enhanceAuthenticatedInputs(root, { login = false } = {}) {
  if (!root?.querySelectorAll || login) return [];
  const enhanced = [];
  root.querySelectorAll('input, textarea').forEach((control) => {
    if (!authenticatedInputEligible(control) || control.dataset.authenticatedInput === 'true') return;
    control.dataset.authenticatedInput = 'true';
    control.classList.add('authenticated-input');
    const containingLabel = control.closest?.('label');
    if (containingLabel) {
      containingLabel.classList.add('authenticated-field');
      const directLabel = [...containingLabel.children].find((child) => child !== control && child.tagName === 'SPAN');
      directLabel?.classList.add('authenticated-field__label');
    } else if (control.parentNode?.insertBefore && control.ownerDocument?.createElement) {
      const wrapper = control.ownerDocument.createElement('label');
      wrapper.className = 'authenticated-field';
      const label = control.ownerDocument.createElement('span');
      label.className = 'authenticated-field__label';
      label.textContent = inferredLabel(control);
      control.parentNode.insertBefore(wrapper, control);
      wrapper.append(control, label);
    }
    enhanced.push(control);
  });
  return enhanced;
}
